// extracted by mini-css-extract-plugin
module.exports = {"wrap":"bq-z","heading":"cq-z","items":"dq-z","featureCss":"eq-z","disabled":"fq-z","imgCss":"gq-z"};